import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useFilterFamilyOptions } from '../../hooks/useFilterFamilyOptions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorFilterSelectStepText = () => {
  const {
    conditionPathToChangeFieldFor,
    draftCondition,
    selectedFilterFamily,
    props: {
      uiMessages: {
        filterSelectionBreadcrumbsStep1,
        filterSelectionBreadcrumbsStep2,
        filterSelectionBreadcrumbsSingleStep
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    hasOnlyOneFilterFamilyOption
  } = useFilterFamilyOptions();
  const isFilterFamilyPredefined = Boolean(draftCondition && draftCondition.isAddingNew && draftCondition.filterFamily);
  if (conditionPathToChangeFieldFor || isFilterFamilyPredefined || hasOnlyOneFilterFamilyOption && !filterSelectionBreadcrumbsSingleStep) {
    return null;
  }
  let message;
  if (hasOnlyOneFilterFamilyOption) {
    message = filterSelectionBreadcrumbsSingleStep;
  } else if (selectedFilterFamily) {
    message = filterSelectionBreadcrumbsStep2 || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.filterSelectStep2"
    });
  } else {
    message = filterSelectionBreadcrumbsStep1 || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.filterSelectStep1"
    });
  }
  return /*#__PURE__*/_jsx(Small, {
    children: message
  });
};
export default EditorFilterSelectStepText;